"use strict";
var privateFns, getInfo;
var kommuneplanDokument = "https://www.oslo.kommune.no/getfile.php/1374702/Innhold/Politikk%20og%20administrasjon/Politikk/Kommuneplan/Ny%20kommuneplan%202015/Kommuneplan%202015%20del%202%20justert%2031.01.2017.pdf";
privateFns = {
	appendHeader: function (text) {
		var header = document.createElement("h3");
		header.innerHTML = text;
		return header;
	},
	appendSubHeader: function (text) {
		var header = document.createElement("h4");
		header.innerHTML = "<strong>" + text + "</strong>";
		return header;
	},
	appendLegendSection: function (text) {
		var section = document.createElement("section");
		section.className = "legend-section";
		section.innerHTML = text;
		return section;
	},
	appendParagraph: function (text, classList) {
		var paragraph = document.createElement("p");
		paragraph.innerHTML = text;
		if(classList){
			paragraph.className = classList;
		}
		return paragraph;
	},
	appendList: function (listItems) {
		var ul = document.createElement("ul");
		listItems.forEach(function (item) {
			var li = document.createElement("li");
			li.innerHTML = item;
			ul.appendChild(li);
		});
		return ul;
	},
	appendIcon: function(icon){
		var ic = document.createElement("i");
		ic.className = icon;
		return ic;
	}, 
	appendLegendRow: function (symbClass, textClass, label) {
		var row = document.createElement("div");
		row.className = "legend-row";
		var symb = document.createElement("div");
		symb.className = symbClass;
		symb.innerHTML = "&nbsp;";
		row.appendChild(symb);
		var text = document.createElement("div");
		text.className = textClass;
		text.innerHTML = label;
		row.appendChild(text);
		return row;
	},
	appendLegendImage: function (image, alternate) {
		var legend = document.createElement("img");
		legend.src = image;
		legend.alt = alternate;
		return legend;
	},
	appendButton: function (classList, ariaLabel){
		var button = document.createElement("button");
		button.setAttribute("type", "button");
		button.setAttribute("aria-label", ariaLabel);
		button.className = classList;
		return button;
	},
	appendDiv: function (id, classList, ariaLabel){
		var div = document.createElement("div");
		div.id = id;
		div.className = classList;
		div.setAttribute("aria-label", ariaLabel);
		return div;
	},
	appendLink: function (id, title, href, ariaLabel){
		var a = document.createElement("a");
		a.id = id;
		a.innerHTML = title;
		a.href = href;
		a.setAttribute("aria-label", ariaLabel);
		a.target = "_blank";
		return a;
	},
	createElement(el){
		if(el.type === "header"){
			return privateFns.appendHeader(el.text);
		}else if(el.type === "subHeader"){
			return privateFns.appendSubHeader(el.text);
		}else if(el.type === "legendSection"){
			return privateFns.appendLegendSection(el.text)
		}else if(el.type === "paragraph"){
			return privateFns.appendParagraph(el.text, el.classList);
		}else if(el.type === "list"){
			return privateFns.appendList(el.listItems);
		}else if(el.type === "icon"){
			return privateFns.appendIcon(el.icon);
		}else if(el.type === "legendRow"){
			return privateFns.appendLegendRow(el.symbClass, el.textClass, el.label);
		}else if(el.type === "legendImage"){
			return privateFns.appendLegendImage(el.image, el.alternate);
		}else if(el.type === "button"){
			return privateFns.appendButton(el.classList, el.ariaLabel);
		}else if(el.type === "div"){
			return privateFns.appendDiv(el.id, el.classList, el.ariaLabel);
		}else if(el.type === "link"){
			return privateFns.appendLink(el.id, el.title, el.href, el.ariaLabel);
		}
	},
};
getInfo = {
	test: [
		{"type": "header", text:"header"},
		{"type": "subHeader", text:"subheader"},
		{"type": "legendSection", text:"legendSection"},
		{"type": "paragraph", text:"paragraph"},
		{"type": "list", listItems:[
			"<a href='https://www.oslo.kommune.no/getfile.php/1374702/Innhold/Politikk%20og%20administrasjon/Politikk/Kommuneplan/Ny%20kommuneplan%202015/Kommuneplan%202015%20del%202%20justert%2031.01.2017.pdf' target='_blank'>kommuneplanens arealdel<i class='icon-new-window'></i></a>",
			"<a href='https://www.oslo.kommune.no/getfile.php/131673/Innhold/Plan%2C%20bygg%20og%20eiendom/Overordnede%20planer/Kommunedelplaner/Kommunedelplan%20akerselva%20milj%C2%9Bpark.pdf' target='_blank'>kommunedelplan for Akerselva miljøpark<i class='icon-new-window'></i></a>"
		]},
		{"type": "icon", icon:"fa fa spinner"},
		{"type": "legendRow", symbClass:"legend-symb legend-postliste", textClass: "legend-text", label:"Postliste"},
		{"type": "legendImage", image: "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=VANN&service=wms&version=1.3.0&request=getLegendGraphic&layer=Vann&format=image/png&sld_version=1.1.0&v=1", alternate:"Stiplet rød linje viser bekker i rør. "},
		{"type": "div", id:"div", classList:"legend-symb", ariaLabel: "divLabel"},
		{"type": "link", id:"linkId", title: "Link Tittle", href: "www.vg.no", ariaLabel: "linkLabel"},
	],
	kp_pk1_arealformaal: function () {
		var el = document.createElement("div");
	/*    el.appendChild(privateFns.appendHeader("Skilt- og reklameplan for Oslo"));
		el.appendChild(privateFns.appendParagraph("Skilt- og reklameplanen for Oslo inneholder retningslinjer for hvilke skilt- og reklameinnretninger som kan settes opp. De juridisk bindende retningslinjene består av generelle regler og spesifikke regler for ulike områder i indre by."));
		el.appendChild(privateFns.appendParagraph("De generelle retningslinjene gjelder for hele den bebygde delen av Oslo. Det er i tillegg regler for fem ulike områdetyper, i hovedsak innenfor Ring 2. Dette kan du se på kartet. I de ulike områdene er det forskjellige regler ut fra hvilken rolle områdene har, tyngden av næring og hvor sårbart området er for reklame."));
		el.appendChild(privateFns.appendParagraph("<a href='https://www.oslo.kommune.no/getfile.php/131019-1443696350/Tjenester og tilbud/Plan%2C bygg og eiendom/Byggesaksveiledere%2C normer og skjemaer/Skilt- og reklameplan for Oslo%2C juridisk bindende.pdfhttps:/www.oslo.kommune.no/getfile.php/131019-1443696350/Tjenester og tilbud/Plan%2C bygg og eiendom/Byggesaksveiledere%2C normer og skjemaer/Skilt- og reklameplan for Oslo%2C juridisk bindende.pdf' target='_blank'>Her kan du lese mer om Skilt- og reklameplanen for Oslo<i class='icon-new-window'></i></a>"));
	*/    el.appendChild(privateFns.appendLegendImage("https://od2.pbe.oslo.kommune.no//cgi-bin/wms?map=KPA24PLAN&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=KpArealformålOmrade&format=image/png"));
		return el;
	} ,    
	vann: function () {
		var el = document.createElement("div");
		el.appendChild(privateFns.appendHeader("Vannveier"));
		el.appendChild(privateFns.appendParagraph("Data fra kommunens tekniske grunnkart som viser forløp og form for elver, bekker, innsjøer, hav, kanaler, grøfter og grenser mellom land og sjø."));
		el.appendChild(privateFns.appendParagraph("Dersom det er åpent vann i nærheten av eiendommen eller planområdet, kan det få betydning hvis du skal bygge eller omregulere."));
		el.appendChild(privateFns.appendParagraph("<a href='https://www.oslo.kommune.no/plan-bygg-og-eiendom/plan-og-bygningsetatens-kundesenter/' target='_blank'>Ta kontakt med Plan- og bygningsetatens kundesenter  <i class='icon-new-window vd-glyphlink glyphicons new_window_alt'></i></a> dersom du har spørsmål."));
		el.appendChild(privateFns.appendSubHeader("Her kan du lese mer om elver og bekker"));
		el.appendChild(privateFns.appendList([
			"<a href='https://www.oslo.kommune.no/getfile.php/1374702-1599727170/Tjenester og tilbud/Politikk og administrasjon/Politikk/Kommuneplan/Tidligere kommuneplandokumenter/Kommuneplan 2015%2C del 2%3A Juridisk arealdel.pdf' target='_blank'>Kommuneplanens arealdel 2015<i class='icon-new-window'></i></a>",
			"<a href=' https://www.oslo.kommune.no/getfile.php/131673-1553524314/Tjenester og tilbud/Plan%2C bygg og eiendom/Overordnede planer/Kommunedelplaner/Kommunedelplan 04%3A Akerselva milj%C3%B8park.pdf' target='_blank'>Akerselva miljøpark (kommunedelplan 4)<i class='icon-new-window'></i></a>",
			"<a href='https://www.oslo.kommune.no/getfile.php/1360428-1553522771/Tjenester og tilbud/Plan%2C bygg og eiendom/Overordnede planer/Kommunedelplaner/Kommunedelplan 18%3A Alna milj%C3%B8park.pdf' target='_blank'>Alna miljøpark (kommunedelplan 18)<i class='icon-new-window'></i></a>",
			"<a href='https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showregbest.asp?planid=15628771' target='_blank'>Lysakervassdraget (kommunedelplan 19)<i class='icon-new-window'></i></a>"
		]));
		el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
		el.appendChild(privateFns.appendLegendImage("https://od2.pbe.oslo.kommune.no//cgi-bin/wms?map=VANN_NY&service=wms&version=1.3.0&request=getLegendGraphic&layer=Vannflater&format=image/png&sld_version=1.1.0&v=1", ""));
		return el;
	}
};

export default {
	getInfoTextFor: function (id) {
		if(getInfo[id]){				
			if(typeof getInfo[id] === "function"){
				return getInfo[id];
			}else {				
				var el = document.createElement("div");
				getInfo[id].forEach(function(elm){
					var appendix = privateFns.createElement(elm);
					el.appendChild(appendix);
				});
				return el;
			}
		}else{
			return;
		}
	},
	getInfoFeature: function(id){
		return getInfo[id];
	},
	addInfoTextFor: function(id, array){
		getInfo[id] = array;
		return getInfo;
	},
};
